import React from 'react'
import logo from '../../images/avatar.jpg'
import * as S from './styled'

const Logo = () => {
  return <S.LogoWrapper src={logo} alt='Avatar' />
}

export default Logo
